import Get from "./Get";
import PastUploads from "./PastUploads";
import Create from "./Create";
import DeletePastPapdisUpload from "./DeletePastPapdisUpload";
import DownloadPAPDISPastUploads from "./DownloadPAPDISPastUploads";

/**
 * @type {{Create: (function(*=): Promise<AxiosResponse<*>>), Get: (function(): Promise<AxiosResponse<*>>)}}
 */
const PAPDISRequests = {
	Get,
	Create,
	PastUploads,
	DeletePastPapdisUpload,
	DownloadPAPDISPastUploads,
}

export default PAPDISRequests;